"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactAcceptFlowContainer = void 0;
var AcceptFlowComponent_1 = require("@CommonFrontend/AcceptFlow/AcceptFlowComponent");
var Types_1 = require("@CommonFrontend/AcceptFlow/Types");
var DIProvider_1 = __importDefault(require("@CommonFrontend/DIProvider/DIProvider"));
var AngularSyncStore_1 = __importStar(require("@CommonFrontend/Utils/AngularSyncStore"));
var PostAcceptRedirect_1 = require("@CommonFrontendBackend/Accept/PostAcceptRedirect");
var pages_common_1 = require("@qwilr/pages-common");
var inversify_1 = require("inversify");
var inversify_react_1 = require("inversify-react");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var AuthenticationContext_1 = require("@CommonFrontend/Public/Identity/AuthenticationContext");
var ReactAcceptFlowContainer = function (_a) {
    var settings = _a.settings, $scope = _a.$scope, $timeout = _a.$timeout, onClose = _a.onClose, onSubmitForm = _a.onSubmitForm, isPreviewAccept = _a.isPreviewAccept, stripePublicKey = _a.stripePublicKey, account = _a.account, optOutSpringboard = _a.optOutSpringboard, projectId = _a.projectId, telemetry = _a.telemetry;
    var _b = __read((0, react_1.useState)(function () { return account.integrations.stripe.enabled; }), 2), isStripeIntegrationEnabled = _b[0], setIsStripeIntegrationEnabled = _b[1];
    (0, react_1.useEffect)(function () {
        return $scope.$watch(function () { return account.integrations.stripe.enabled; }, function (nextIsStripeIntegrationEnabled) {
            setIsStripeIntegrationEnabled(nextIsStripeIntegrationEnabled);
        });
    }, []);
    return (react_1.default.createElement(DIProvider_1.default, { container: function () {
            var container = new inversify_1.Container({ skipBaseClassChecks: true });
            container.bind("settings").toConstantValue(settings);
            container.bind(AcceptFlowSettingsStore).toSelf();
            container.bind(AngularSyncStore_1.AngularSyncServices.$).toConstantValue({ $scope: $scope, $timeout: $timeout });
            return container;
        } },
        react_1.default.createElement(ReactAcceptFlow, { onClose: onClose, onSubmitForm: onSubmitForm, autofillEnabled: true, isPreviewAccept: isPreviewAccept, isStripeIntegrationEnabled: isStripeIntegrationEnabled, stripePublicKey: stripePublicKey, postAcceptRedirectUrl: (0, PostAcceptRedirect_1.getFinalRedirectURL)(settings.postAcceptance.url, {
                pageId: projectId,
                preview: true,
            }), optOutSpringboard: optOutSpringboard, isPrintMode: false, telemetry: telemetry })));
};
exports.ReactAcceptFlowContainer = ReactAcceptFlowContainer;
var ReactAcceptFlow = (0, mobx_react_1.observer)(function (props) {
    var settings = (0, inversify_react_1.useInjection)(AcceptFlowSettingsStore).settings;
    return (react_1.default.createElement(AuthenticationContext_1.AuthenticationContextProvider, { authAppBaseUrl: "" },
        react_1.default.createElement(pages_common_1.AuthenticationContextProvider, { isSignedIn: false, isInitialized: true, signOut: function () { return Promise.resolve(); }, getToken: function () { return Promise.resolve(""); } },
            react_1.default.createElement(pages_common_1.SpringboardContextProvider, { authAppBaseUrl: "", springboardAppBaseUrl: "", consumerDataServiceUrl: "", pageHash: "" },
                react_1.default.createElement(AcceptFlowComponent_1.AcceptFlow, __assign({ settings: settings }, props))))));
});
var AcceptFlowSettingsStore = (function (_super) {
    __extends(AcceptFlowSettingsStore, _super);
    function AcceptFlowSettingsStore(angularSyncServices, settings) {
        var _this = _super.call(this, settings, angularSyncServices, { extractDataFromAngular: lodash_1.identity }) || this;
        _this.onAngularUpdated = function (newData) {
            _this._settings = newData;
        };
        _this.angularSettings = settings;
        _this.onAngularUpdated(settings);
        return _this;
    }
    Object.defineProperty(AcceptFlowSettingsStore.prototype, "dataForAngular", {
        get: function () {
            return this.angularSettings;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AcceptFlowSettingsStore.prototype, "settings", {
        get: function () {
            return this._settings;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof Types_1.AcceptFlowSettings !== "undefined" && Types_1.AcceptFlowSettings) === "function" ? _a : Object)
    ], AcceptFlowSettingsStore.prototype, "_settings", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AcceptFlowSettingsStore.prototype, "onAngularUpdated", void 0);
    AcceptFlowSettingsStore = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)(AngularSyncStore_1.AngularSyncServices.$)),
        __param(1, (0, inversify_1.inject)("settings")),
        __metadata("design:paramtypes", [typeof (_b = typeof AngularSyncStore_1.AngularSyncServices !== "undefined" && AngularSyncStore_1.AngularSyncServices) === "function" ? _b : Object, typeof (_c = typeof Types_1.AcceptFlowSettings !== "undefined" && Types_1.AcceptFlowSettings) === "function" ? _c : Object])
    ], AcceptFlowSettingsStore);
    return AcceptFlowSettingsStore;
}(AngularSyncStore_1.default));
